import gql from 'graphql-tag';

export const EditorStartHeartbeatMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation EditorStartHeartbeatMutation(
			$contentId: ID!
			$contentType: String!
			$collabService: String!
			$heartbeatUserType: ExperimentalHeartbeatUserType
		) @experimental {
			experimentalEditorStartHeartbeat(
				contentId: $contentId
				contentType: $contentType
				collabService: $collabService
				heartbeatUserType: $heartbeatUserType
			) {
				orderedUsers {
					accountId
					heartbeatUserType
				}
				editorSessionId
				error
				message
				subtype
			}
		}
	`;
